import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import KanbanColumn from './KanbanColumn';

const useStyles = makeStyles(theme => ({
  board: {
    display: 'flex',
    overflowX: 'auto',
    ...theme.scrollbarStyles,
    padding: theme.spacing(2),
    gap: theme.spacing(0),
    alignItems: 'flex-start',
  },
}));

const KanbanBoard = ({ lanes, onCardMove, onLaneReorder, updateTicket, isAdmin }) => {
  const classes = useStyles();

  const handleDragEnd = result => {
    console.log('[KANBAN-DEBUG] handleDragEnd fired:', JSON.stringify(result));

    if (!result.destination) {
      console.log('[KANBAN-DEBUG] No destination — drag cancelled');
      return;
    }

    const { source, destination, draggableId, type } = result;
    console.log('[KANBAN-DEBUG] type:', type, '| draggableId:', draggableId);
    console.log('[KANBAN-DEBUG] source.droppableId:', source.droppableId, '→ destination.droppableId:', destination.droppableId);

    // Se for reordenação de lane
    if (type === 'LANE') {
      console.log('[KANBAN-DEBUG] Lane reorder:', source.index, '→', destination.index);
      if (source.index !== destination.index) {
        onLaneReorder(source.index, destination.index);
      }
      return;
    }

    // Se for movimentação de card
    if (
      source.droppableId !== destination.droppableId ||
      source.index !== destination.index
    ) {
      console.log('[KANBAN-DEBUG] Calling onCardMove with ticketId:', draggableId, 'targetLane:', destination.droppableId);
      onCardMove(
        draggableId,
        destination.droppableId,
        source.droppableId,
        source.index,
        destination.index
      );
    } else {
      console.log('[KANBAN-DEBUG] Same position — no move needed');
    }
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="lanes" direction="horizontal" type="LANE">
        {(provided, snapshot) => (
          <div 
            className={classes.board}
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {lanes.map((lane, index) => (
              <KanbanColumn
                key={lane.id}
                id={lane.id}
                title={lane.title}
                tickets={lane.tickets}
                color={lane.color}
                index={index}
                updateTicket={updateTicket}
                isAdmin={isAdmin}
              />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default KanbanBoard;
